import { getApp } from 'firebase/app'
import { beginLiveRoute } from '~/utils/liveData'

/**
 * Live data on the client (utils/liveData.ts, docs/LiveData.md):
 *
 * - A store read that no component holds is held by the route it ran on, and
 *   let go (to linger two minutes, then stop) when the next route begins.
 * - Firestore runs on its in-memory cache. The persistent IndexedDB cache this
 *   app used to keep went stale in long-lived profiles (every read took
 *   seconds, LEARNINGS 2026-10-23), so what a browser still has of it goes.
 */
export default defineNuxtPlugin(() => {
  beginLiveRoute()
  useRouter().afterEach(() => {
    beginLiveRoute()
  })
  deleteOldFirestoreCache()
})

function deleteOldFirestoreCache() {
  try {
    const projectId = getApp().options.projectId
    if (!projectId || typeof indexedDB === 'undefined') return
    // Waits for any tab still running the old app to close
    indexedDB.deleteDatabase(`firestore/[DEFAULT]/${projectId}/main`)
    // The multi-tab manager's bookkeeping
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('firestore_')) localStorage.removeItem(key)
    }
  }
  catch (error) {
    console.warn('[live-data] Could not clear the old Firestore cache:', error)
  }
}
